import { render, staticRenderFns } from "./SpSalesReport.vue?vue&type=template&id=54aba035"
import script from "./SpSalesReport.vue?vue&type=script&lang=js"
export * from "./SpSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports